import {
    SCREENS_PROGRESS,
    SCREENS,
    SCREENS_BY_ID_PROGRESS,
    SCREENS_BY_ID
} from '../actions/screensAction'

export const screensReducer = (state={}, action) => {
    switch(action.type){
        case SCREENS_PROGRESS:
            return {loading: true}
        case SCREENS:
            return action.data
        default:
        return state
    }
}

export const screensByIdReducer = (state={}, action) => {
    switch(action.type){
        case SCREENS_BY_ID_PROGRESS:
            return true
        case SCREENS_BY_ID:
            return action.data
        default:
        return state
    }
}